export default __webpack_public_path__ + "static/media/icon-chevron-down.98562007.svg";